import React from 'react';
import { usePathBuilder } from '../../core/routing/hooks/use-path-builder';
import { Link } from '../link/link';
import { ProductLine } from '../product-line/product-line';
import { ArticleThumbnail } from '../article-thumbnail/article-thumbnail';
import styles from './article-mini-preview.module.scss';

type Props = {
  hexCode: string | undefined;
  series: string;
  seriesNumber: string;
  pimArticleId: string;
  hasRendering: boolean;
};

export const ArticleMiniPreview: React.FC<Props> = ({ hexCode, series, seriesNumber, pimArticleId, hasRendering }) => {
  const { articlePath } = usePathBuilder();

  return (
    <div className={styles.root}>
      <ArticleThumbnail mini articleId={pimArticleId} hasRendering={hasRendering} hexCode={hexCode} />
      <div className={styles.content}>
        <Link to={articlePath(pimArticleId)}>{pimArticleId}</Link>
        <ProductLine series={series} seriesNumber={seriesNumber} />
      </div>
    </div>
  );
};
